import styled from 'styled-components';
import { Flexbox, Text } from '@morressier/ts';
import { faIdCardClip } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const EmptyStateIconContainer = styled.div`
  background-color: var(--color-mono-95);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 8rem;
  height: 8rem;
`;

export const EmptyStateContainer = styled(Flexbox)`
  margin-top: 4rem;
`;

export const EmptyStateIcon = styled(FontAwesomeIcon)`
  font-size: var(--fontSizes-xxl);
  line-height: var(--lineHeights-xl);
  font-weight: var(--fontWeights-semi);
  color: var(--color-mono-80);
`;
const EmptyState = () => {
  return (
    <EmptyStateContainer flexDirection="column" alignItems={'center'} gap={16}>
      <EmptyStateIconContainer>
        <EmptyStateIcon icon={faIdCardClip} />
      </EmptyStateIconContainer>
      <Text>This user hasn’t completed their profile yet.</Text>
    </EmptyStateContainer>
  );
};
export default EmptyState;
